<template>
  <div
    class="columns is-gapless vadLineNotification is-marginless"
    :class="{'has-background-light' : !event.is_new}">
    <div class="column is-narrow is-padding-left-small">
      <avatar
        v-if="event.is_new"
        class="has-text-white"
        :class="['has-background-notification']"
        :item="{}"
        :is-avatar="false"
        :force-picto="true"
        :use-picto-custom="'fal fa-bell'"></avatar><!-- v-if="event.is_new" -->
    </div>
    <div class="column is-padding-top-xsmall is-padding-right-small is-padding-bottom-xsmall is-padding-left-small">
      <p class="has-text-grey is-size-7">
        {{ since }}
      </p>
      <a
        :href="href"
        class="is-size-4"><strong>{{ title }}</strong></a>
      <div
        v-show="description !== ''"
        class="is-size-6 has-text-grey">
        {{ description }}
      </div>
    </div>
    <div
      class="column is-narrow actionsOnRow"
      :class="{'actionsOnRow--vertical' : event.is_new}">
      <!-- <div v-if="action === 'remove'">
        <button @click="removeEvent"
                class="button is-white is-fullwidth">
          <span class="icon is-small"><i class="fas fa-trash-alt"></i></span>
        </button>
      </div> -->
      <div v-if="event.is_new">
        <button
          @click="markAsSeen"
          class="button is-white is-fullwidth">
          <span class="icon is-small"><i class="fal fa-check-circle"></i></span>
        </button>
      </div>
      <div v-else>
        <button
          class="button is-white is-fullwidth has-background-light"
          style="cursor: unset;">
          <span class="icon is-small"><i class="fal fa-eye"></i></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'

export default {
  name: 'LineNotification',
  mixins: [Quickview, DefaultValues],
  props: {
    href: {
      required: false,
      type: String
    },
    event: {
      required: true,
      type: Object
    },
    since: {
      required: true,
      type: String
    },
    title: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String
    },
    action: {
      required: false,
      type: String,
      default: 'update'
    },
    displayVerticalActions: {
      required: false,
      type: Boolean,
      default: true
    },
    displayNotiSettingsBtn: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    removeEvent () {
      this.$emit('removeEvent', this.event.pk)
    },
    markAsSeen () {
      this.$emit('updateEvent', this.event.pk, {
        is_new: false
      })
    }
  }
}
</script>
